"use client";

import { CustomDialog } from "@/components/custom/dialog";
import { Typography } from "@/components/custom/typography";

export default function ConfirmDialog({
  title,
  content,
  open = false,
  onCancel,
  onOk,
  size = "sm",
  classNameTitle = "text-xl text-gray-900",
  ...rest
}: {
  title?: string;
  content?: string | React.ReactNode;
  cancelText?: string;
  okText?: string;
  open: boolean;
  onCancel: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onOk: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  okButtonVariant?: "primary" | "destructive";
  size?: "sm" | "md" | "lg" | "xl" | "xs" | "2xl";
  classNameTitle?: string;
}) {
  return (
    <CustomDialog
      size={size}
      cancelText="저장 안 함"
      okText="임시 저장"
      onOkClick={() => {
        onOk?.();
      }}
      classNameTitle={`text-xl text-gray-900 ${classNameTitle}`}
      open={open}
      onOpenChange={() => onCancel()}
      title={title}
      description={
        <Typography className="whitespace-pre-line" as="span" variant="body2">
          {content}
        </Typography>
      }
      {...rest}
    />
  );
}
